export const defaultCommodityPercentageObject = {
  commodity: null,
  percentage: null,
};

export default {
  commodityPercentages: [defaultCommodityPercentageObject],
};
